import { Card, CardBody } from "@heroui/react";
import { SunIcon, MoonIcon, MonitorIcon } from "@phosphor-icons/react";
import { useShallow } from "zustand/shallow";

import { useBoundStore } from "@/app/store";
import { IconComponent, Theme } from "@/types/common";

export function ThemeStep() {
  const { userId, theme, updateSettings } = useBoundStore(
    useShallow((state) => ({
      userId: state.user.id,
      theme: state.settings.app.theme,
      updateSettings: state.settings.updateSettings,
    }))
  );

  const handleThemeChange = (newTheme: Theme) => {
    if (userId) {
      updateSettings(userId, { app: { ...useBoundStore.getState().settings.app, theme: newTheme } });
    }
  };

  interface ThemeOption {
    id: Theme;
    label: string;
    icon: IconComponent;
    description: string;
  }

  const themes: ThemeOption[] = [
    {
      id: "light",
      label: "Light",
      icon: SunIcon,
      description: "Bright and easy on the eyes",
    },
    {
      id: "dark",
      label: "Dark",
      icon: MoonIcon,
      description: "Easy on the eyes at night",
    },
    {
      id: "system",
      label: "System",
      icon: MonitorIcon,
      description: "Match your device settings",
    },
  ];

  return (
    <div className="flex h-full flex-col gap-3">
      {themes.map(({ id, label, icon: Icon, description }) => (
        <Card className="grow-1" key={id} isPressable onClick={() => handleThemeChange(id)}>
          <CardBody className="gap-3 p-4">
            <div className="flex w-full justify-between">
              <div className="flex-1">
                <p className="font-medium">{label}</p>
                <p className="text-default-500 text-xs">{description}</p>
              </div>
              <div className="border-primary flex h-5 w-5 items-center justify-center rounded-full border-2">
                {theme === id && <div className="bg-primary h-2.5 w-2.5 rounded-full" />}
              </div>
            </div>
            <Icon className="text-default-500 m-auto text-5xl sm:text-7xl" weight="duotone" />
          </CardBody>
        </Card>
      ))}
    </div>
  );
}
